(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  function cartAddDeliveryDays(days, excludeWeekends) {
    var date = new Date();
    date.setHours(12, 0, 0, 0);
    var added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (!excludeWeekends || (date.getDay() !== 0 && date.getDay() !== 6)) added += 1;
    }
    if (excludeWeekends) while (date.getDay() === 0 || date.getDay() === 6) date.setDate(date.getDate() + 1);
    return date;
  }

  function cartFormatDeliveryDate(date) {
    return new Intl.DateTimeFormat(document.documentElement.lang || 'de-CH', { weekday: 'short', day: '2-digit', month: 'short' }).format(date);
  }

  function renderCartDelivery(root) {
    root.querySelectorAll('[data-cart-delivery-root]').forEach(function (cartRoot) {
      var excludeWeekends = cartRoot.dataset.excludeWeekends === 'true';
      cartRoot.querySelectorAll('[data-cart-delivery-date]').forEach(function (element) {
        var minDays = Number(element.dataset.minDays || 0);
        var maxDays = Number(element.dataset.maxDays || minDays);
        var minDate = cartFormatDeliveryDate(cartAddDeliveryDays(minDays, excludeWeekends));
        var maxDate = cartFormatDeliveryDate(cartAddDeliveryDays(maxDays, excludeWeekends));
        element.textContent = minDays === maxDays ? minDate : minDate + ' – ' + maxDate;
      });
    });
  }

  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-cart-quantity]');
    if (!input) return;
    var item = input.closest('[data-cart-item-delivery]');
    var root = input.closest('[data-cart-delivery-root]');
    var flow = item.dataset.deliveryMode;
    if (flow === 'auto') {
      var managed = item.dataset.managed === 'true';
      var inventory = Number(item.dataset.inventory || 0);
      flow = item.dataset.available === 'false' || (managed && Number(input.value || 0) > inventory) ? 'production' : 'stock';
    }
    item.dataset.flow = flow;
    item.querySelectorAll('[data-cart-flow]').forEach(function (node) { node.hidden = node.dataset.cartFlow !== flow; });
    var status = item.querySelector('[data-cart-delivery-status]');
    if (status) status.textContent = flow === 'stock' ? root.dataset.stockLabel : root.dataset.productionLabel;
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { renderCartDelivery(document); });
  else renderCartDelivery(document);
  document.addEventListener('shopify:section:load', function (event) { renderCartDelivery(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('pointerover', function (event) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var thumb = event.target.closest('[data-media-target]');
    if (!thumb || thumb.contains(event.relatedTarget)) return;
    activateMedia(thumb.closest('[data-product-gallery]'), thumb.dataset.mediaTarget, false);
  });

  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-media-target]');
    if (target) activateMedia(target.closest('[data-product-gallery]'), target.dataset.mediaTarget);
    var gallery = event.target.closest('[data-product-gallery]');
    if (gallery && (event.target.closest('[data-gallery-prev]') || event.target.closest('[data-gallery-next]'))) {
      var thumbs = Array.from(gallery.querySelectorAll('[data-media-target]'));
      var current = gallery.querySelector('[data-media-target].is-active');
      var index = Math.max(0, thumbs.indexOf(current));
      index += event.target.closest('[data-gallery-prev]') ? -1 : 1;
      if (index < 0) index = thumbs.length - 1;
      if (index >= thumbs.length) index = 0;
      activateMedia(gallery, thumbs[index].dataset.mediaTarget);
    }
    var section = event.target.closest('[data-product-section]');
    if (!section) return;
    var carouselButton = event.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (carouselButton) {
      var carousel = carouselButton.closest('[data-upsell], [data-video-gallery]').querySelector('[data-carousel-track]');
      var step = carousel.firstElementChild ? carousel.firstElementChild.getBoundingClientRect().width + 10 : carousel.clientWidth;
      carousel.scrollBy({ left: carouselButton.hasAttribute('data-carousel-prev') ? -step : step, top: carouselButton.hasAttribute('data-carousel-prev') ? -step : step, behavior: 'smooth' });
    }
    var quantity = section.querySelector('[data-quantity-input]');
    if (quantity && event.target.closest('[data-quantity-minus]')) quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    if (quantity && event.target.closest('[data-quantity-plus]')) quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
    if (event.target.closest('[data-mobile-submit]') && section.querySelector('[data-product-submit]')) section.querySelector('[data-product-submit]').click();
  });

  document.addEventListener('change', function (event) {
    var upsellSelector = event.target.closest('[data-upsell-variant]');
    if (upsellSelector) {
      var upsellOption = upsellSelector.options[upsellSelector.selectedIndex];
      upsellSelector.closest('form').querySelector('[data-upsell-price]').textContent = upsellOption.dataset.price;
      return;
    }
    var selector = event.target.closest('[data-product-variant-selector]');
    if (!selector) return;
    var option = selector.options[selector.selectedIndex];
    var section = selector.closest('[data-product-section]');
    var available = option.dataset.available === 'true';
    var price = section.querySelector('[data-product-price]');
    if (price) price.textContent = option.dataset.price;
    var mobilePrice = section.querySelector('[data-mobile-price]');
    if (mobilePrice) mobilePrice.textContent = option.dataset.price;
    var compare = section.querySelector('[data-product-compare-price]');
    if (compare) {
      compare.textContent = option.dataset.comparePrice || '';
      compare.hidden = !!section.querySelector('[data-submit-price]') || !option.dataset.comparePrice;
    }
    var sale = section.querySelector('[data-sale-badge]');
    var priceRaw = Number(option.dataset.priceRaw || 0);
    var compareRaw = Number(option.dataset.compareRaw || 0);
    if (sale) {
      sale.textContent = compareRaw > priceRaw ? '-' + Math.round((compareRaw - priceRaw) * 100 / compareRaw) + '%' : '';
      sale.hidden = compareRaw <= priceRaw;
    }
    var button = section.querySelector('[data-product-submit]');
    var mobileButton = section.querySelector('[data-mobile-submit]');
    if (button) {
      button.disabled = !available;
      button.querySelector('[data-submit-label]').textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
    }
    if (mobileButton) mobileButton.disabled = !available;
    var submitPrice = button && button.querySelector('[data-submit-price]');
    if (submitPrice) {
      submitPrice.textContent = ' - ' + option.dataset.price;
      submitPrice.hidden = !available;
    }
    var mobileSubmitPrice = mobileButton && mobileButton.querySelector('[data-mobile-submit-price]');
    if (mobileSubmitPrice) {
      mobileSubmitPrice.textContent = ' - ' + option.dataset.price;
      mobileSubmitPrice.hidden = !available;
    }
    var stock = section.querySelector('[data-stock-status]');
    var inventory = Number(option.dataset.inventory || 0);
    var managed = option.dataset.managed === 'true';
    var threshold = Number(section.dataset.lowStockThreshold || 5);
    var lowStock = available && managed && inventory > 0 && inventory <= threshold;
    if (stock) {
      stock.classList.toggle('is-sold-out', !available);
      stock.classList.toggle('is-low', lowStock);
      var stockText = stock.querySelector('[data-stock-text]');
      if (stockText) {
        var statusLabel = available ? (lowStock ? section.dataset.lowStockLabel : section.dataset.inStockLabel) : section.dataset.soldOutLabel;
        if (lowStock && section.dataset.showStockQuantity === 'true') statusLabel += ' · ' + inventory;
        stockText.textContent = statusLabel;
      }
    }
    var delivery = section.querySelector('[data-delivery-text]');
    if (delivery) delivery.hidden = !available;
    var deliveryMode = section.dataset.deliveryMode;
    if (deliveryMode === 'auto') deliveryMode = available && (!managed || inventory > 0) ? 'stock' : 'production';
    section.querySelectorAll('[data-delivery-flow]').forEach(function (flow) { flow.hidden = flow.dataset.deliveryFlow !== deliveryMode; });
    var deliveryStatus = section.querySelector('[data-delivery-status]');
    if (deliveryStatus) {
      var deliveryLabel = deliveryMode === 'stock' ? section.dataset.stockFlowLabel : section.dataset.productionFlowLabel;
      if (deliveryMode === 'stock' && inventory > 0 && section.dataset.flowShowStockCount === 'true') deliveryLabel = inventory + ' ' + deliveryLabel;
      deliveryStatus.textContent = deliveryLabel;
    }
    var sku = section.querySelector('[data-product-sku]');
    if (sku) sku.textContent = option.dataset.sku || '—';
    if (option.dataset.mediaId) activateMedia(section.querySelector('[data-product-gallery]'), option.dataset.mediaId);
    var url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url.toString());
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-upsell-form]');
    if (!form) return;
    event.preventDefault();
    var button = form.querySelector('button[type="submit"]');
    button.disabled = true;
    var root = window.Shopify && Shopify.routes && Shopify.routes.root || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function (response) {
      if (!response.ok) throw new Error('cart');
      return fetch(root + 'cart.js');
    }).then(function (response) { return response.json(); }).then(function (cart) {
      document.querySelectorAll('.cart-count').forEach(function (count) { count.textContent = cart.item_count; });
      button.textContent = button.dataset.addedLabel;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    }).catch(function () {
      form.submit();
    }).finally(function () {
      button.disabled = false;
      window.setTimeout(function () { button.textContent = button.dataset.addLabel; }, 2200);
    });
  });

  function activateMedia(gallery, mediaId, scrollThumb) {
    if (!gallery || !mediaId) return;
    gallery.querySelectorAll('[data-media-id]').forEach(function (item) {
      var active = item.dataset.mediaId === String(mediaId);
      item.hidden = !active;
      item.classList.toggle('is-active', active);
      if (!active) item.querySelectorAll('video').forEach(function (video) { video.pause(); });
    });
    gallery.querySelectorAll('[data-media-target]').forEach(function (thumb) {
      var active = thumb.dataset.mediaTarget === String(mediaId);
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (active && scrollThumb !== false) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  }

  function addDeliveryDays(days, excludeWeekends) {
    var date = new Date();
    date.setHours(12, 0, 0, 0);
    var added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (!excludeWeekends || (date.getDay() !== 0 && date.getDay() !== 6)) added += 1;
    }
    if (excludeWeekends) {
      while (date.getDay() === 0 || date.getDay() === 6) date.setDate(date.getDate() + 1);
    }
    return date;
  }

  function formatDeliveryDate(date) {
    var locale = document.documentElement.lang || 'de-CH';
    return new Intl.DateTimeFormat(locale, { weekday: 'short', day: '2-digit', month: 'short' }).format(date);
  }

  function renderDeliveryDates(section) {
    var excludeWeekends = section.dataset.excludeWeekends === 'true';
    section.querySelectorAll('[data-delivery-date]').forEach(function (element) {
      var minDays = Number(element.dataset.minDays || 0);
      var maxDays = Number(element.dataset.maxDays || minDays);
      var minDate = formatDeliveryDate(addDeliveryDays(minDays, excludeWeekends));
      var maxDate = formatDeliveryDate(addDeliveryDays(maxDays, excludeWeekends));
      element.textContent = minDays === maxDays ? minDate : minDate + ' – ' + maxDate;
    });
  }

  function initializeDeliveryDates(root) {
    root.querySelectorAll('[data-product-section]').forEach(renderDeliveryDates);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeDeliveryDates(document); });
  } else {
    initializeDeliveryDates(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initializeDeliveryDates(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rocket-about-world"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-about-world]').forEach((section) => {
    const clock = section.querySelector('[data-world-clock]');
    if (!clock) return;
    const updateClock = () => { clock.textContent = `${new Date().toISOString().slice(11, 19)} UTC`; };
    updateClock();
    window.setInterval(updateClock, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rocket-parallax"] && !Shopify.designMode) return;
  try {
    
  function initRocketMotionSlider(root) {
    if (!root || root.dataset.motionSliderReady === 'true') return;
    const slides = Array.from(root.querySelectorAll('[data-motion-slide]'));
    if (slides.length < 2) return;
    const copies = Array.from(root.querySelectorAll('[data-motion-copy-panel]'));
    const dots = Array.from(root.querySelectorAll('[data-motion-dot]'));
    const stageLabel = root.querySelector('[data-motion-stage-label]');
    let active = 0;

    function selectSlide(index) {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === active);
        slide.classList.toggle('is-before', slideIndex < active);
        slide.setAttribute('aria-hidden', String(slideIndex !== active));
      });
      copies.forEach((panel, panelIndex) => {
        panel.classList.toggle('is-active', panelIndex === active);
        panel.setAttribute('aria-hidden', String(panelIndex !== active));
      });
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === active);
        dot.setAttribute('aria-pressed', String(dotIndex === active));
      });
      if (stageLabel) stageLabel.textContent = slides[active].dataset.stageLabel || '';
    }

    dots.forEach(dot => dot.addEventListener('click', () => selectSlide(Number(dot.dataset.motionIndex))));

    root.dataset.motionSliderReady = 'true';
    selectSlide(0);
  }

  document.querySelectorAll('[data-misaki-section]').forEach(initRocketMotionSlider);
  document.addEventListener('shopify:section:load', event => {
    initRocketMotionSlider(event.target.querySelector('[data-misaki-section]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rocket-side-promo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = root => {
      root.querySelectorAll('[data-rocket-side-promo]').forEach(promo => {
        if (promo.dataset.initialized === 'true') return;
        promo.dataset.initialized = 'true';

        const panel = promo.querySelector('[data-promo-panel]');
        const closeButton = promo.querySelector('[data-promo-close]');
        const openButton = promo.querySelector('[data-promo-open]');
        const storageKey = promo.dataset.storageKey;
        const rememberClose = promo.dataset.rememberClose === 'true';
        const designMode = Boolean(window.Shopify && window.Shopify.designMode);
        let dismissed = false;

        if (rememberClose && !designMode) {
          try {
            dismissed = window.sessionStorage.getItem(storageKey) === 'closed';
          } catch (error) {
            dismissed = false;
          }
        }

        const setOpen = (isOpen, moveFocus = false) => {
          promo.hidden = false;
          promo.classList.add('is-ready');
          promo.classList.toggle('is-collapsed', !isOpen);
          panel.setAttribute('aria-hidden', String(!isOpen));

          if (openButton) {
            openButton.hidden = isOpen;
            openButton.setAttribute('aria-expanded', String(isOpen));
          }

          if (moveFocus) {
            if (isOpen) closeButton.focus();
            if (!isOpen && openButton) openButton.focus();
          }
        };

        closeButton.addEventListener('click', () => {
          if (rememberClose && !designMode) {
            try {
              window.sessionStorage.setItem(storageKey, 'closed');
            } catch (error) {
              dismissed = true;
            }
          }
          setOpen(false, true);
        });

        if (openButton) {
          openButton.addEventListener('click', () => setOpen(true, true));
        }

        promo.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !promo.classList.contains('is-collapsed')) {
            setOpen(false, true);
          }
        });

        if (dismissed) {
          setOpen(false);
          return;
        }

        const delay = designMode ? 0 : Number(promo.dataset.delay || 0);
        window.setTimeout(() => setOpen(true), delay);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document));
    } else {
      initialize(document);
    }

    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
